import { z } from 'zod';

export const addressSchema = z.object({
  postal_code: z.string(),
  house_number: z.number(),
  house_number_letter: z.string().nullish(),
  house_number_addition: z.string().nullish(),
  house_number_extension: z.string().nullish(),
  street: z.string(),
  city: z.string(),
});

export type IAddressState = z.infer<typeof addressSchema>;
